import $ from 'jquery';

$( () => {
  const images = $( '.gallery-image img' );
  const totalImages = images.length;
  let currentIndex = 0;

  $('.gallery-image-overlay').click(function() {
    currentIndex = $(this).parent().index();
    displayImage(currentIndex);

    $( '.gallery-overlay' ).fadeIn();
  });

  $( '.gallery-overlay' ).click( function( e ) {
    if ( $( e.target ).hasClass( 'gallery-overlay' ) ) {
      $( this ).fadeOut();
    }
  });

  $( '.gallery-btn.prev' ).click(function() {
    currentIndex = ( currentIndex - 1 + totalImages ) % totalImages;
    displayImage( currentIndex );
  });

  $( '.gallery-btn.next' ).click( function() {
    currentIndex = ( currentIndex + 1 ) % totalImages;
    displayImage( currentIndex );
  });

  function displayImage( index ) {
    const imageUrl = $(images[ index ]).attr( 'src' );
    $( '.gallery-overlay img' ).attr( 'src', imageUrl );

    $( '#gallery-count' ).html(`${String( index + 1 ).padStart( 2, '0' )} / ${String( totalImages ).padStart( 2, '0' )}`)
  }
});